import { handleActions } from "redux-actions";

import { removeById, updateById } from "utils";

const companyUserReducer = handleActions(
  {
    COMPANY_USERS_GET: {
      FULFILLED: (state, { payload }) => ({
        companyUsers: payload.users,
      }),
    },
    COMPANY_USER_EDIT: (state, { meta }) => ({
      companyUsers: updateById(state.companyUsers, {
        id: meta.userID,
        isEdit: meta.isEdit,
      }),
    }),
    COMPANY_USER_REMOVE_FULFILLED: (state, { meta }) => ({
      companyUsers: removeById(state.companyUsers, meta.userID),
    }),
    COMPANY_USER_SAVE_FULFILLED: (state, action) => ({
      companyUsers: updateById(state.companyUsers, {
        ...action.payload.user,
        isEdit: false,
      }),
      currentUser:
        action.payload.user.id === state.currentUser.id
          ? {
              ...state.currentUser,
              roleInCompany: action.payload.user.roleInCompany,
            }
          : state.currentUser,
    }),
    COMPANY_USER_CREATE_FULFILLED: (state, action) => ({
      companyUsers: [...state.companyUsers, action.payload.user],
    }),
  },
  {},
  { namespace: "_" }
);

export default companyUserReducer;
